module Tapas.ViewModels {
    export enum Mode { List = "list" as any, Grid = "grid" as any };

    export class ProductListViewModel extends Tapas.ViewModels.CartViewModel {
        public mode: KnockoutObservable<Mode>;
        public productListLoad = ko.observable(false);      

        constructor() {
            super();
            this.mode = ko.observable<Mode>(Mode.List);
        }
        public toggleView = () => {
            switch (this.mode() as any) {
                case "list":
                    this.mode(Mode.Grid);
                    break;

                case "grid":
                    this.mode(Mode.List);
                    break;
            }
        }        
    }
}